import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=299f774c&scoped=true"
import script from "./SideBar.vue?vue&type=script&lang=js"
export * from "./SideBar.vue?vue&type=script&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=299f774c&prod&lang=scss"
import style1 from "./SideBar.vue?vue&type=style&index=1&id=299f774c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299f774c",
  null
  
)

export default component.exports